export const PROJECT_NOTES_AUTO_SAVE_DEBOUNCE_MS = 600;

/**
 * Обёртка кнопок `IconActionButton` в таблицах (заметки/сессии/файлы).
 * Исключаем из useClickOutside заметок — иначе mousedown по другой строке закрывает попап до onClick.
 */
export const PROJECTS_TABLE_ICON_ACTION_WRAP_SELECTOR = '.projects-table__notes-btn-wrap';
